<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-header">
        <div class="login-logo">🎫</div>
        <div class="login-title">{{ merchantName || 'Sweetour' }}</div>
        <div class="login-subtitle"></div>
      </div>

      <div v-if="!urlMerchantId" class="merchant-error">
        <div class="error-icon">⚠️</div>
        <div class="error-text">支付成功请返回App点击已完成付款;未支付可返回重新支付。</div>
        <div class="error-sub">请通过商户专属链接访问</div>
      </div>

      <template v-else>
        <div class="login-form">
          <div class="form-group">
            <div class="auth-mode-tabs">
              <button class="mode-tab-btn" :class="{ active: authMode === 'login' }" @click="authMode = 'login'">登录</button>
              <button class="mode-tab-btn" :class="{ active: authMode === 'register' }" @click="authMode = 'register'">注册</button>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">手机号</label>
            <input v-model="phone" type="tel" class="form-input" placeholder="请输入手机号" @keyup.enter="authMode === 'login' ? handleLogin() : handleRegister()" />
          </div>

          <div class="form-group">
            <label class="form-label">密码</label>
            <input v-model="password" type="password" class="form-input" placeholder="请输入密码" @keyup.enter="authMode === 'login' ? handleLogin() : handleRegister()" />
          </div>

          <template v-if="authMode === 'register'">
            <div class="form-group">
              <label class="form-label">确认密码</label>
              <input v-model="confirmPassword" type="password" class="form-input" placeholder="请再次输入密码" @keyup.enter="handleRegister()" />
            </div>
          </template>

          <div class="form-group">
            <button
              class="login-btn"
              :disabled="!phone || !password || (authMode === 'register' && !confirmPassword) || loading"
              @click="authMode === 'login' ? handleLogin() : handleRegister()"
            >
              <span v-if="!loading">{{ authMode === 'login' ? '登录' : '注册' }}</span>
              <span v-else>{{ authMode === 'login' ? '登录中...' : '注册中...' }}</span>
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getUrlMerchantId, setUrlMerchantId } from '@/utils/storage'

export default {
  name: 'Login',
  data() {
    return {
      authMode: 'login',
      phone: '',
      password: '',
      confirmPassword: '',
      loading: false,
      urlMerchantId: null,
      merchantName: ''
    }
  },
  async mounted() {
    // 优先从路由参数获取商户ID，其次从 localStorage
    const mid = this.$route.query.merchantid || this.$route.query.merchantId || this.$route.query.MerchantId
    if (mid) {
      setUrlMerchantId(mid)
      this.urlMerchantId = parseInt(mid)
    } else {
      const stored = getUrlMerchantId()
      this.urlMerchantId = stored ? parseInt(stored) : null
    }

    if (!this.urlMerchantId) return

    await this.loadMerchantName()
  },
  methods: {
    async loadMerchantName() {
      try {
        await this.$store.dispatch('user/fetchMerchants')
        const merchants = this.$store.state.user.merchants
        const m = merchants.find(x => x.id === this.urlMerchantId || String(x.id) === String(this.urlMerchantId))
        if (m) this.merchantName = m.merchantName
      } catch (e) { console.error(e) }
    },
    async handleLogin() {
      if (!this.phone) { this.$alert('请输入手机号'); return }
      if (!this.password) { this.$alert('请输入密码'); return }
      this.loading = true
      try {
        const res = await this.$store.dispatch('user/phonePasswordLogin', {
          merchantId: this.urlMerchantId,
          phone: this.phone,
          password: this.password
        })
        if (res.code === 200) {
          this.$router.replace('/')
        } else {
          this.$alert(res.message || '登录失败')
        }
      } catch (e) {
        this.$alert(e.message || '登录失败，请重试')
      } finally {
        this.loading = false
      }
    },
    async handleRegister() {
      if (!this.phone) { this.$alert('请输入手机号'); return }
      if (!this.password) { this.$alert('请输入密码'); return }
      if (!this.confirmPassword) { this.$alert('请确认密码'); return }
      if (this.password !== this.confirmPassword) { this.$alert('两次密码不一致'); return }
      this.loading = true
      try {
        const res = await this.$store.dispatch('user/phonePasswordRegister', {
          merchantId: this.urlMerchantId,
          phone: this.phone,
          password: this.password
        })
        if (res.code === 200) {
          this.$router.replace('/')
        } else {
          this.$alert(res.message || '注册失败')
        }
      } catch (e) {
        this.$alert(e.message || '注册失败，请重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #ffa43a 0%, #ff720d 58%, #e85d04 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-container {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-logo { font-size: 48px; margin-bottom: 16px; }
.login-title { font-size: 24px; font-weight: 700; color: #111827; margin-bottom: 4px; }
.login-subtitle { font-size: 14px; color: #6b7280; }

.merchant-error {
  text-align: center;
  padding: 24px 0;
}
.error-icon { font-size: 48px; margin-bottom: 12px; }
.error-text { font-size: 16px; font-weight: 600; color: #374151; margin-bottom: 8px; }
.error-sub { font-size: 13px; color: #6b7280; }

.login-form { margin-bottom: 20px; }

.form-group { margin-bottom: 20px; }

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}

.auth-mode-tabs {
  display: flex;
  gap: 10px;
}

.mode-tab-btn {
  flex: 1;
  padding: 10px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;

  &:hover { border-color: #ff720d; color: #ff720d; }
  &.active { border-color: #ff720d; background: #ff720d; color: #fff; }
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: #fff;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #ff720d;
    box-shadow: 0 0 0 3px rgba(255, 114, 13, 0.12);
  }
  &::placeholder { color: #9ca3af; }
}

.login-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(90deg, #ffa43a 0%, #ff720d 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active:not(:disabled) { opacity: 0.85; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
}
</style>
